import React from 'react';
import NewProperty from './NewProperty';

const AddProperty = () => {
    return (
        <NewProperty />
    )
}

export default AddProperty